(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.dlsInitialized) return;
    const form = root.querySelector('.dls-form');
    if (!form || typeof DataTransfer === 'undefined') return;
    root.dataset.dlsInitialized = 'true';
    const chooser = root.querySelector('[data-dls-chooser]');
    const slots = [...root.querySelectorAll('[data-dls-file-slot]')];
    const list = root.querySelector('[data-dls-photo-list]');
    const error = root.querySelector('[data-dls-photo-error]');
    const count = root.querySelector('[data-dls-photo-count]');
    const zone = root.querySelector('[data-dls-upload-zone]');
    let files = [];
    let urls = [];
    zone.hidden = false;
    root.querySelector('[data-dls-native-photos]').hidden = true;
    slots.forEach(slot => slot.required = false);
    chooser.required = true;
    function sync() {
      slots.forEach((slot, index) => {
        const transfer = new DataTransfer();
        if (files[index]) transfer.items.add(files[index]);
        slot.files = transfer.files;
        slot.disabled = !files[index];
      });
      urls.forEach(url => URL.revokeObjectURL(url));
      urls = [];
      list.replaceChildren();
      files.forEach((file, index) => {
        const card = document.createElement('div'); card.className = 'dls-photo-card';
        const image = document.createElement('img'); const url = URL.createObjectURL(file);
        urls.push(url); image.src = url; image.alt = file.name;
        const caption = document.createElement('span'); caption.textContent = file.name;
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = '×';
        remove.setAttribute('aria-label', `${root.dataset.removeLabel} ${index + 1}`);
        remove.addEventListener('click', () => {
          files.splice(index, 1); chooser.value = '';
          chooser.required = files.length === 0; error.textContent = ''; sync();
        });
        card.append(image, caption, remove); list.append(card);
      });
      count.textContent = `${files.length} / 6`;
      chooser.required = files.length === 0;
    }
    function validate(candidate) {
      if (candidate.length > 6) return root.dataset.errorCount;
      if (candidate.some(file => !['image/jpeg','image/png'].includes(file.type))) return root.dataset.errorType;
      if (candidate.some(file => file.size > 10 * 1024 * 1024)) return root.dataset.errorSize;
      if (candidate.reduce((size,file) => size + file.size, 0) > 40 * 1024 * 1024) return root.dataset.errorTotal;
      return '';
    }
    chooser.addEventListener('change', () => {
      const proposed = files.concat([...chooser.files]);
      const message = validate(proposed);
      error.textContent = message;
      if (message) { chooser.value = ''; return; }
      files = proposed; sync();
    });
    form.addEventListener('submit', event => {
      const message = !files.length ? root.dataset.errorEmpty : validate(files);
      if (message) {
        event.preventDefault(); error.textContent = message; chooser.focus(); return;
      }
      const button = root.querySelector('[data-dls-submit]');
      button.setAttribute('aria-busy','true');
    });
    const variant = root.querySelector('select[data-dls-variant]');
    if (variant) variant.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      root.querySelector('[data-dls-price]').textContent = option.dataset.price;
      root.querySelector('[data-dls-submit]').disabled = option.dataset.available !== 'true';
    });
  }
  const initializeAll = () => document.querySelectorAll('[data-dls-custom]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
